// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__fWGYj","title":"style_title__ygjD5","fadeIn":"style_fadeIn__7BSHI"};